module.exports = __webpack_public_path__ + "img/product1.af91b963.jpg";